import { EnumColor } from '@40seas/frontend/common/providers';
import { AirwallexIntentStatus } from 'libs/entities/airwallex/src/lib/airwallex-intent.entity';

export const airwallexIntentStatusColorMapping = {
    [AirwallexIntentStatus.RequiresPaymentMethod]: 'info',
    [AirwallexIntentStatus.RequiresCapture]: 'info',
    [AirwallexIntentStatus.RequiresCustomerAction]: 'info',
    [AirwallexIntentStatus.Pending]: 'default',
    [AirwallexIntentStatus.Succeeded]: 'success',
    [AirwallexIntentStatus.Cancelled]: 'error',
} as {
    [key in AirwallexIntentStatus]: EnumColor;
};
